<template>
  <!DOCTYPE html>
  <html>
    <head>
      <title>Login</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="description" content="Destino project" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="stylesheet" type="text/css" href="/styles/bootstrap4/bootstrap.min.css" />
      <link
        href="/plugins/font-awesome-4.7.0/css/font-awesome.min.css"
        rel="stylesheet"
        type="text/css"
      />
      <link rel="stylesheet" type="text/css" href="/styles/offers_styles.css" />
      <link rel="stylesheet" type="text/css" href="/styles/offers_responsive.css" />
    </head>
    <body>
      <div class="home">
        <!-- Image by https://unsplash.com/@peecho -->
        <div
          class="home_background parallax-window"
          data-parallax="scroll"
          style="background-image: url(/images/offers.jpg)"
          data-speed="0.8"
        ></div>
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="home_content">
                <div class="home_content_inner">
                  <div class="home_title">Login</div>
                  <div class="home_breadcrumbs">
                    <ul class="home_breadcrumbs_list">
                      <li class="home_breadcrumb"><a href="index.html">Marena</a></li>
                      <li class="home_breadcrumb">Login</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_title text-center">
        <h2>Zaloguj się</h2>
      </div>
      <div class="container" @keyup.enter="login">
        <input v-model="username" class="m-input" placeholder="Email" type="email" />
        <input v-model="password" class="m-input" placeholder="Hasło" type="password" />
        <button class="m-button" :disabled="loading" @click="login">
          <i v-show="loading" class="fa fa-spinner fa-spin" />
          Zaloguj
        </button>
      </div>

      <script2 src="/js/jquery-3.2.1.min.js"></script2>
      <script2 src="/styles/bootstrap4/popper.js"></script2>
      <script2 src="/styles/bootstrap4/bootstrap.min.js"></script2>
      <script2 src="/plugins/greensock/TweenMax.min.js"></script2>
      <script2 src="/plugins/greensock/TimelineMax.min.js"></script2>
      <script2 src="/plugins/scrollmagic/ScrollMagic.min.js"></script2>
      <script2 src="/plugins/greensock/animation.gsap.min.js"></script2>
      <script2 src="/plugins/greensock/ScrollToPlugin.min.js"></script2>
      <script2 src="/plugins/Isotope/isotope.pkgd.min.js"></script2>
      <script2 src="/plugins/easing/easing.js"></script2>
      <script2 src="/plugins/parallax-js-master/parallax.min.js"></script2>
      <script2 src="/js/offers_custom.js"></script2>
    </body>
  </html>
</template>

<script>
import cli from '@/http.js'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions(['loginUser']),
    async login() {
      this.loading = true
      const data = {
        username: this.username,
        password: this.password,
      }
      try {
        await this.loginUser(data)
        this.$router.push({ name: 'home' })
      } catch (err) {
        this.$notify({
          title: 'Login',
          text: err.message,
          type: 'error',
        })
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.container {
  min-height: 400px;
  text-align: center;
}
</style>
